import { actions } from "./actions";
import { initialState } from "./constants";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_CONFIG_REQUEST:
      return {
        ...state,
        getConfig: {
          loading: true,
          success: false,
          error: false,
        },
      };
    case actions.GET_CONFIG_SUCCESS:
      return {
        ...state,
        getConfig: {
          loading: false,
          success: true,
          error: false,
          data: action.payload,
        },
      };
    case actions.GET_CONFIG_FAILURE:
      return {
        ...state,
        getConfig: {
          loading: false,
          success: false,
          error: true,
        },
      };
    default:
      return state;
  }
};
export { reducer, actions, initialState };
